var _circle, _path, _mask, _path2, _path3, _mask2, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFairemoj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16,
    r: 13,
    stroke: "#33363F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 22.0226C12.2019 21.9068 12.9285 21.8185 13.7587 21.7586C14.5967 21.6981 15.5407 21.6667 16.4974 21.6667C17.4541 21.6667 18.3981 21.6981 19.236 21.7586C20.0663 21.8185 20.7929 21.9068 21.3278 22.0226",
    stroke: "#33363F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_2148_122807",
    maskUnits: "userSpaceOnUse",
    x: 10.1641,
    y: 12,
    width: 5,
    height: 4,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 10.1641,
    y: 12,
    width: 5,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3307 13.3333C13.5739 13.3333 13.6954 13.3333 13.7699 13.4426C13.8443 13.5519 13.8089 13.6418 13.7381 13.8217C13.6717 13.9904 13.5709 14.1455 13.4402 14.2761C13.1902 14.5262 12.851 14.6667 12.4974 14.6667C12.1438 14.6667 11.8046 14.5262 11.5546 14.2761C11.4239 14.1455 11.3231 13.9904 11.2567 13.8217C11.1859 13.6418 11.1505 13.5519 11.2249 13.4426C11.2994 13.3333 11.4209 13.3333 11.6641 13.3333L12.4974 13.3333H13.3307Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3307 13.3333C13.5739 13.3333 13.6954 13.3333 13.7699 13.4426C13.8443 13.5519 13.8089 13.6418 13.7381 13.8217C13.6717 13.9904 13.5709 14.1455 13.4402 14.2761C13.1902 14.5262 12.851 14.6667 12.4974 14.6667C12.1438 14.6667 11.8046 14.5262 11.5546 14.2761C11.4239 14.1455 11.3231 13.9904 11.2567 13.8217C11.1859 13.6418 11.1505 13.5519 11.2249 13.4426C11.2994 13.3333 11.4209 13.3333 11.6641 13.3333L12.4974 13.3333H13.3307Z",
    fill: "#33363F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3307 13.3333C13.5739 13.3333 13.6954 13.3333 13.7699 13.4426C13.8443 13.5519 13.8089 13.6418 13.7381 13.8217C13.6717 13.9904 13.5709 14.1455 13.4402 14.2761C13.1902 14.5262 12.851 14.6667 12.4974 14.6667C12.1438 14.6667 11.8046 14.5262 11.5546 14.2761C11.4239 14.1455 11.3231 13.9904 11.2567 13.8217C11.1859 13.6418 11.1505 13.5519 11.2249 13.4426C11.2994 13.3333 11.4209 13.3333 11.6641 13.3333L12.4974 13.3333H13.3307Z",
    stroke: "#33363F",
    strokeLinecap: "round",
    mask: "url(#path-3-outside-1_2148_122807)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-2_2148_122807",
    maskUnits: "userSpaceOnUse",
    x: 18.1641,
    y: 12,
    width: 5,
    height: 4,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 18.1641,
    y: 12,
    width: 5,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3307 13.3333C21.5739 13.3333 21.6954 13.3333 21.7699 13.4426C21.8443 13.5519 21.8089 13.6418 21.7381 13.8217C21.6717 13.9904 21.5709 14.1455 21.4402 14.2761C21.1902 14.5262 20.851 14.6667 20.4974 14.6667C20.1438 14.6667 19.8046 14.5262 19.5546 14.2761C19.4239 14.1455 19.3231 13.9904 19.2567 13.8217C19.1859 13.6418 19.1505 13.5519 19.2249 13.4426C19.2994 13.3333 19.4209 13.3333 19.6641 13.3333L20.4974 13.3333H21.3307Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3307 13.3333C21.5739 13.3333 21.6954 13.3333 21.7699 13.4426C21.8443 13.5519 21.8089 13.6418 21.7381 13.8217C21.6717 13.9904 21.5709 14.1455 21.4402 14.2761C21.1902 14.5262 20.851 14.6667 20.4974 14.6667C20.1438 14.6667 19.8046 14.5262 19.5546 14.2761C19.4239 14.1455 19.3231 13.9904 19.2567 13.8217C19.1859 13.6418 19.1505 13.5519 19.2249 13.4426C19.2994 13.3333 19.4209 13.3333 19.6641 13.3333L20.4974 13.3333H21.3307Z",
    fill: "#33363F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3307 13.3333C21.5739 13.3333 21.6954 13.3333 21.7699 13.4426C21.8443 13.5519 21.8089 13.6418 21.7381 13.8217C21.6717 13.9904 21.5709 14.1455 21.4402 14.2761C21.1902 14.5262 20.851 14.6667 20.4974 14.6667C20.1438 14.6667 19.8046 14.5262 19.5546 14.2761C19.4239 14.1455 19.3231 13.9904 19.2567 13.8217C19.1859 13.6418 19.1505 13.5519 19.2249 13.4426C19.2994 13.3333 19.4209 13.3333 19.6641 13.3333L20.4974 13.3333H21.3307Z",
    stroke: "#33363F",
    strokeLinecap: "round",
    mask: "url(#path-4-outside-2_2148_122807)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFairemoj);
export default __webpack_public_path__ + "static/media/fairemoj.bede4e939c8a0008986d9ea8422a19a0.svg";
export { ForwardRef as ReactComponent };